import React from 'react';
import Box from '@mui/joy/Box';
import Typography from '@mui/joy/Typography';
import Tabs from '@mui/joy/Tabs';
import TabList from '@mui/joy/TabList';
import Tab from '@mui/joy/Tab';
import TabPanel from '@mui/joy/TabPanel';
import { StatisticsSubTab } from './inventorySync/StatisticsSubTab';
import { ProxiesSubTab } from './inventorySync/ProxiesSubTab';
import { SettingsSubTab } from './inventorySync/SettingsSubTab';

export function InventorySyncTab() {
    const [activeSubTab, setActiveSubTab] = React.useState<number>(0);

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, flex: 1, minHeight: 0 }}>
            <Typography level="h3" sx={{ fontSize: { xs: 'xl', sm: 'xl2' } }}>Синк инвентарей</Typography>

            <Tabs
                value={activeSubTab}
                onChange={(_event, value) => setActiveSubTab(typeof value === 'number' ? value : 0)}
                sx={{ bgcolor: 'transparent', flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}
            >
                <TabList size="sm" sx={{ overflowX: 'auto', flexWrap: 'nowrap' }}>
                    <Tab value={0}>Статистика</Tab>
                    <Tab value={1}>Прокси</Tab>
                    <Tab value={2}>Настройки</Tab>
                </TabList>

                <TabPanel value={0} sx={{ flex: 1, overflow: 'auto', px: 0, pt: 1.5 }}>
                    <StatisticsSubTab isActive={activeSubTab === 0} />
                </TabPanel>

                <TabPanel value={1} sx={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column', px: 0, pt: 1.5, minHeight: 0 }}>
                    <ProxiesSubTab isActive={activeSubTab === 1} />
                </TabPanel>

                <TabPanel value={2} sx={{ flex: 1, overflow: 'auto', px: 0, pt: 1.5 }}>
                    <SettingsSubTab isActive={activeSubTab === 2} />
                </TabPanel>
            </Tabs>
        </Box>
    );
}

export default InventorySyncTab;
